const popupModule = document.querySelector('.popup-module');

if (popupModule) {
  const setPopupCookie = () => {
    const popupExpireDate = popupModule.getAttribute('expire-date');
    Cookies.set('popup-cookie', true, { expires: Number(popupExpireDate || 1), secure: true });
  };

  // **********************************************************
  // Close Popup When Escape Key Press
  // **********************************************************

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const modalElem = document.querySelectorAll('.popup-module');
      modalElem.forEach((el) => {
        el.classList.remove('is-open-modal');
        toggleOpenModalClass(false);
        setPopupCookie();
      });
    }
  });

  // **********************************************************
  // Close Popup When Click On Outside
  // **********************************************************

  attachEvent('.popup-module__close,.popup-module__overlay', 'click', (ev) => {
    const parentEle = ev.target.closest('.popup-module');
    parentEle.classList.remove('is-open-modal');
    toggleOpenModalClass(false);
    ev.preventDefault();
  });

  // *********************************************************************
  // Store popup-cookie when click on close btn, popup btn and offer card
  // *********************************************************************

  attachEvent('.popup-module__close, .popup-module__button, .popup-module .stretched-link', 'click', () => {
    setPopupCookie();
  });

  const isOpen = !Cookies.get('popup-cookie');
  popupModule.classList.toggle('hide', !isOpen);
  popupModule.classList.toggle('is-open-modal', isOpen);
  document.body.classList.toggle('body-modal-open', isOpen);
  if (!popupModule.querySelector('.small')) {
    document.body.classList.toggle('body-scroll-locked', isOpen);
  }
}
